import { render, staticRenderFns } from "./Colecao.vue?vue&type=template&id=0c4fe398&scoped=true"
import script from "./Colecao.vue?vue&type=script&lang=js"
export * from "./Colecao.vue?vue&type=script&lang=js"
import style0 from "./Colecao.vue?vue&type=style&index=0&id=0c4fe398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fe398",
  null
  
)

export default component.exports